import React, { useState, useEffect } from 'react';
import './MonthlyTimer.css';

function MonthlyTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  
  const calculateTimeLeft = () => {
    // Sofia's birthdate: January 4, 2025
    const birthDate = new Date(2025, 0, 4);
    const now = new Date();
    
    // Calculate how many months have passed since birth
    let monthsPassed = (now.getFullYear() - birthDate.getFullYear()) * 12 + now.getMonth() - birthDate.getMonth();
    
    // Adjust if we haven't reached the same day of the month yet
    if (now.getDate() < birthDate.getDate()) {
      monthsPassed--;
    }
    
    // Calculate the next monthly anniversary
    const nextMonthAnniversary = new Date(birthDate);
    nextMonthAnniversary.setMonth(birthDate.getMonth() + monthsPassed + 1);
    
    // Calculate time difference
    const difference = nextMonthAnniversary - now;
    
    // If already passed today, return zeros
    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    
    // Calculate remaining time
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  };

  useEffect(() => {
    // Initial calculation
    setTimeLeft(calculateTimeLeft());
    
    // Update every second
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    
    // Cleanup on unmount
    return () => clearInterval(timer);
  }, []);

  const nextMonthNumber = () => {
    const birthDate = new Date(2025, 0, 4);
    const now = new Date();
    
    let monthsPassed = (now.getFullYear() - birthDate.getFullYear()) * 12 + now.getMonth() - birthDate.getMonth();
    
    if (now.getDate() < birthDate.getDate()) {
      monthsPassed--;
    }
    
    return monthsPassed + 1;
  };

  return (
    <div className="monthly-timer">
      <h3>До {nextMonthNumber()}-месячного юбилея осталось:</h3>
      <div className="timer-display">
        <div className="timer-unit">
          <div className="timer-value">{timeLeft.days}</div>
          <div className="timer-label">дней</div>
        </div>
        <div className="timer-unit">
          <div className="timer-value">{timeLeft.hours}</div>
          <div className="timer-label">часов</div>
        </div>
        <div className="timer-unit">
          <div className="timer-value">{timeLeft.minutes}</div>
          <div className="timer-label">минут</div>
        </div>
        <div className="timer-unit">
          <div className="timer-value">{timeLeft.seconds}</div>
          <div className="timer-label">секунд</div>
        </div>
      </div>
    </div>
  );
}

export default MonthlyTimer; 